<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
    </div>
    <div ref="content">
      <el-form ref="srForm" :model="formData" :rules="rules" label-width="120px" v-if="!$isMobile()">
        <el-row>
          <el-col :span="12">
            <el-form-item label="IDC명" prop="idcCd">
              <!-- {{ formData.idcCdHnglNm }} -->
              <el-select
                class="modal-input-box"
                v-model="formData.idcCd"
                size="small"
                :placeholder="$t('messages.plSelect')"
                :disabled="!isWrite"
              >
                <el-option
                  v-for="(item, index) in idcCdList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="등록일시"> {{ formData.regDt }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="완료희망일" prop="cmpltHopd">
              <el-date-picker
                v-model="formData.cmpltHopd"
                size="mini"
                type="date"
                align="right"
                value-format="yyyyMMdd"
                placeholder="YYYY/MM/DD"
                class="modal-input-box-date"
                :disabled="!isWrite"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="제목" prop="title">
              <idc-input
                class="modal-input-box-title"
                v-model="formData.title"
                size="small"
                :placeholder="$t('messages.plTitle')"
                :disabled="!isWrite"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="ly-el-row-title">
          <el-col>
            <idc-editor class="modal-input-box-title" 
              :editorHtmlContent="formData.sbst" 
              @getEditorContent="editorContent"
              :isWrite="isWrite"
              ref="editor"
            />
          </el-col>
        </el-row>
      </el-form>
      
      <el-form ref="srForm" :model="formData" :rules="rules" label-width="120px" v-else>
        <el-row>
          <el-col :span="24">
            <el-form-item label="IDC명" prop="idcCd">
              <!-- {{ formData.idcCdHnglNm }} -->
              <el-select
                class="modal-input-box"
                v-model="formData.idcCd"
                size="small"
                :placeholder="$t('messages.plSelect')"
                :disabled="!isWrite"
              >
                <el-option
                  v-for="(item, index) in idcCdList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="등록일시"> {{ formData.regDt }}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="완료희망일" prop="cmpltHopd">
              <el-date-picker
                v-model="formData.cmpltHopd"
                size="mini"
                type="date"
                align="right"
                value-format="yyyyMMdd"
                placeholder="YYYY/MM/DD"
                class="modal-input-box-date"
                :disabled="!isWrite"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="제목" prop="title">
              <idc-input
                class="modal-input-box-title"
                v-model="formData.title"
                size="small"
                :placeholder="$t('messages.plTitle')"
                :disabled="!isWrite"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="ly-el-row-title">
          <el-col>
            <idc-editor class="modal-input-box-title" 
              :editorHtmlContent="formData.sbst" 
              @getEditorContent="editorContent"
              :isWrite="isWrite"
              ref="editor"
            />
          </el-col>
        </el-row>
      </el-form>
      <div class="btn-box" v-if="isWrite || !isTemplate && !$isMobile()">
        <el-button type="save" size="large" @click="onSave" v-if="isWrite"
          :disabled="isTemplate">{{ $t("messages.btnSave") }}</el-button>
      </div>
    </div>
    <!-- 고객사검색 -->
    <idc-modal
      :visible.sync="dialogUser"
      :title="$t('messages.titClientSearch')"
      width="900px"
      :close-on-click-modal="false"
    >
      <template #content>
        <cust-svc-search-modal
          @modalSelect="clientSelect"
          :idcCd="formData.idcCd"
          ref="custSvcModal"
        />
        <div slot="footer" class="dialog-footer align-r">
          <el-button type="primary" @click="closeModal">
            {{ $t("messages.plSelectOp") }}
          </el-button>
        </div>
      </template>
    </idc-modal>
    <!-- SR 요청자 ED -->
    <idc-modal
      :visible.sync="dialogSrCust"
      :title="$t('messages.titRqtrUserSearch')"
      width="1140px"
    >
      <template #content>
        <wrk-sr-cust-list-modal 
          ref="searchSrCustModal"
          @closeCustListModal="closeCustListModal"
          :keywordCheck="keywordCheck"
          @selectedCustInfo="selectedCustInfo"
          @selectCustMember="selectCustMember"
        >
        </wrk-sr-cust-list-modal>
      </template>
    </idc-modal>
    <!-- 사용자검색 -->
     <idc-modal
      :visible.sync="modalUserRoleList"
      title="권한 사용자 선택"
      width="1550px"
    >
      <template #content>
        <role-user-list-modal @selectedRoleUserInfo="selectedRoleUserInfo" 
          @closeRoleUserModal="modalUserRoleList = false;"/>
      </template>
    </idc-modal>
  </div>
</template>

<script>
import { getDateTime, getYMD, fileSizeCheck, fileExtCheck, commonFileDownload } from "@/assets/js/common.js";
import IdcInput from "@/components/common/IdcInput.vue";
import IdcEditor from "@/components/wrkManageComponents/commonComponents/IdcEditor.vue";
import IdcModal from "@/components/common/IdcModal.vue";
import WrkSrCustListModal from "@/components/listComponents/wrkComponents/modal/WrkSrCustListModal";
import RoleUserListModal from "@/components/systemMgComponents/modal/RoleUserListModal";
import FileSaver from "file-saver";
import IdcFileUpload from "@/components/common/IdcFileUpload.vue";
import CustSvcSearchModal from "@/components/supportComponents/modal/CustSvcSearchModal.vue";

export default {
  components: {
    IdcInput,
    IdcEditor,
    IdcModal,
    WrkSrCustListModal,
    RoleUserListModal,
    IdcFileUpload,
    CustSvcSearchModal
  },
  props: {
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: { 
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: ''
    },
    scrnGetApi: {
      type: String,
      default: ''
    },
    scrnPostApi: {
      type: String,
      default: ''
    },
    scrnPutApi: {
      type: String,
      default: ''
    },
    scrnDeleteApi: {
      type: String,
      default: ''
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn:{
      type: String,
      default: 'N'
    },
    sftyChkMandChkYn: {
      type: String,
      default: 'N'
    },
    sftyChkScrnYn: {
      type: String,
      default: 'N'
    },
    callDate: {
      type: Number,
      default: -1
    },
    stepCd: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      dialogUser : false,
      preLength: 0,
      preFileList: [],
      fileList: [],
      fileForm:{
        data:{

        }
      },
      modalUserRoleList: false,
      dialogSrCust: false,
      keywordCheck: 0,
      formData: {
        regDt : getYMD(getDateTime(), "-")
      },
      idcCdList: [],
      svcRqtTypeCdList: [],
      rqtrTypeCdList: [
        {
          label : '고객사',
          value : 0
        },
        {
          label : '비고객사',
          value : 1
        },
      ],
      rules: {
        tgtCtlogId    : { required: true, message: " ", trigger: "change" },
        svcRqtTypeCd  : { required: true, message: " ", trigger: "change" },
        idcCd         : { required: true, message: " ", trigger: "change" },
        title         : { required: true, message: " ", trigger: "blur" },
        cmpltHopd      : { required: true, message: " ", trigger: "blur" },
        custNm        : { required: true, message: " ", trigger: "blur" },
      },
    };
  },
  mounted() {
    this.setidcCd();
    this.getWrkComnRegApyInfo(true);
  },
  watch: {
    isWrite(){
      console.log(this.isWrite, 'fkdlfkl')
      this.$refs.editor.setOptions({ editable : this.isWrite }); 
    },
    prcssTrtDataCnctId() {
      this.getWrkComnRegApyInfo(true);
    },
  },
  methods: {
    clientSelect(val){
      this.formData.custId = val.custId;
      this.formData.custNm = val.custHnglNm;
      this.formData.svcNo = val.svcNo;
    },
    closeModal() {
      this.dialogUser = false;
    },
    openCustModal(){
      if(this.formData.idcCd == ""){
        alert("DC를 선택해주세요.");
        return;
      }
      this.dialogUser = true;
      this.$nextTick(function () {
        this.$refs.custSvcModal.resetModal();
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    handleChange : function (file, fileList) {
      if (fileSizeCheck(file.raw, 100)) {
        if (fileExtCheck(file.raw)) {
          this.files = file.raw;
          this.fileList = fileList;
        } else {
          alert("파일 확장자를 확인하세요.");
          this.fileList = [];
        }
      } else {
        alert("파일 업로드 최대 사이즈는 100MB 입니다.");
        this.fileList = [];
      }
      if(file.size == 0){
        alert("파일 사이즈가 0KB 인 파일은 업로드할 수 없습니다.");
        this.fileList = [];
      }
    },
    removeCalFile(removeFile){
      this.fileList = this.fileList.filter(file=>removeFile !== file);
      // this.fileList.splice(index, 1);
      // this.fileList = fileList;
    },
    removePreFile(removeFile) {
      this.preFileList = this.preFileList.filter(file=>removeFile.atcFileSeq !== file.atcFileSeq);
    },
    downloadFile(file) {
      commonFileDownload(this.$BIZ_SERVICE, FileSaver, file, this.$API_URLS.Wrk.fileDownloadWrkComnAtcFile);
    },
    rqtrTypeCdChange(){
      //요청자유형 변경시 기존 선택 데이터 초기화
      this.formData.rqtrNm = "";
      this.formData.rqtCustNm = "";
      this.formData.rqtCustId = "";
      this.formData.operrTypeCd = "";
      this.formData.rqtrTypeNm = "";
      this.formData.cmpnNm = "";
      this.formData.mphon = "";
      this.formData.email = "";
      this.formData.custId = "";
      this.formData.custNm = "";
      this.formData.svcNo = "";
    },
    //권한 사용자 선택 모달에서 선택 된 데이터 매핑
    selectedRoleUserInfo(selectedRole, selectedUser) {
      this.rqtrTypeCdChange();

      this.modalUserRoleList = false;
      // console.log(selectedRole, 'selectedRole~~~')
      // console.log(selectedUser, 'selectedUser~~~')
      //모달에서 권한그룹만 선택시 그룹, 사용자를 선택했다면 사용자이름이 보이도록
      if(selectedUser.userNm == null || selectedUser.userNm == ''){
        this.formData.rqtrNm = selectedRole.roleNm;
        this.formData.rqtrId = selectedRole.roleId;
      }else{
        this.formData.rqtrNm = selectedUser.userNm;
        this.formData.rqtrId = selectedUser.userId;
      }

      //this.formData.rqtrTypeNm = selectedUser.companyCd;
      this.formData.ustNm = selectedUser.companyNm;
      this.formData.cmpnNm = selectedUser.deptCd;
      this.formData.posDept = selectedUser.deptNm;
      this.formData.mphon = selectedUser.hp;
      this.formData.email = selectedUser.email;
    },
    selectedCustInfo(custData){
      this.rqtrTypeCdChange();
      this.formData = Object.assign({}, this.formData
                                    , {rqtCustNm:custData.custNm
                                        , rqtCustId:custData.custId})

      this.dialogSrCust = false;
      this.keywordCheck = true;
      this.$refs.searchSrCustModal.resetData();                                        
    },
    selectCustMember(val){
      this.rqtrTypeCdChange();
      //console.log(val, '부모~~~')
      //this.formData = val;
      this.formData = Object.assign({}, this.formData
                                    , {rqtrNm:val.nm
                                        , rqtrId:val.custMembSeq
                                        , rqtCustNm:val.custHnglNm
                                        , rqtCustId:val.custId
                                        , operrTypeCd:val.operrTypeCd
                                        , rqtrTypeNm:val.operrTypeCdNm
                                        , cmpnNm:val.cmpnNm
                                        , mphon:val.mphon
                                        , email:val.email
                                      });

      this.dialogSrCust = false;
      this.keywordCheck = true;
      this.$refs.searchSrCustModal.resetData();
    },
    closeCustListModal(){
      this.dialogSrCust = false;
      this.keywordCheck = true;
      this.$refs.searchSrCustModal.resetData();
    },
    editorContent : function (value) {
      this.formData.sbst = value;
    },
    openModal(){
      let rqtrTypeCdCheck = this.formData.rqtrTypeCd;
      
      if(typeof rqtrTypeCdCheck == 'undefined'){
        alert('요청자유형을 선택해주세요.')
        return;
      }

      if(rqtrTypeCdCheck == 0){
        //고객사 팝업
        this.dialogSrCust = true;
      }else{
        //비고객사 팝업
        this.modalUserRoleList = true;
      }

      this.keywordCheck++;
    },
    setidcCd(){
      let idcResData = [];

      this.$BIZ_SERVICE
      .post(this.$API_URLS.Com.getIdcCdList, {})
      .then((res) => {
        if (res.data !== "") {
          res.data.resData.map((data) => {
            idcResData.push({
              label: data.idcCdNm,
              value: data.idcCd,
            });
          });
        }
      })
      .catch((error) => {})
      .finally(() => {
        this.idcCdList = idcResData;
      });
    },
    async getWrkComnRegApyInfo(initFlag) {
      if (initFlag) {
        if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
          this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId;
        }
        else{
          if(this.defaultValue && Object.keys(this.defaultValue).length > 0){
            this.formData = this.defaultValue;
          }
          return;
        }
      }
      const data = await this.$BIZ_SERVICE
      //조회 API - /v1/wrk/getWrkComnRegApyInfo
      .post(this.scrnGetApi, {prcssTrtDataCnctId: this.currPrcssTrtDataCnctId})
      //console.log(data.data.resData,'res.data.resData.')
      if (data.data.resData) {
        this.formData = data.data.resData || {};
        //고객사 유무 체크
        let rqtrTypeCd = "";

        this.formData = Object.assign({}, this.formData
                                    , {rqtrTypeCd : rqtrTypeCd
                                        , regDt : this.formData.regDt});
      }
    },
    //워크플로우 필수 데이터 삽입
    setReqData(){
      this.formData.exeWflowId  = this.exeWflowId
      this.formData.prcssId     = this.subPrcssId
      this.formData.stepCd      = this.stepCd
      this.formData.scrnId      = this.scrnId
      // this.form.data.scrnActionId = this.scrnActonList     //TODO 확인 필요
      // this.form.data.trtrId       = this.ticketInfo.trtrId // TODO 스케줄에서 조회 시 오류나서 임시 막음
      this.formData.ticktId     = (this.ticketInfo ? this.ticketInfo.ticktId : null)
      this.formData.mainPrcssId = this.mainPrcssId
      this.formData.subPrcssId  = this.subPrcssId
      this.formData.prcssTrtDataCnctId = this.currPrcssTrtDataCnctId
      this.formData.wflowScrnId = this.wflowScrnId
    },
    validateForm() {
      let result = true;
      this.$refs.srForm.validate((valid) => {
        if (!valid) {
          result = false;
          return;
        }
      });

      return result;
    },
    //저장
    async onSave() {
      if(!this.validateForm()){
        alert("필수 값을 입력하세요.");
        return;
      }

      if (!confirm("저장하시겠습니까?")) return;

      this.setReqData();

      /* var obj ={};
      obj.wrkSrInfo = this.formData */

      this.$BIZ_SERVICE.post(this.scrnPostApi, {baseInfo : this.formData})
      //저장API /v1/wrk/postWrkComnRegApyInfo
      .then((res) => {
        //저장 성공 후 공정처리연결ID 재매핑
        this.currPrcssTrtDataCnctId = res.data.resData;
        
        alert("등록되었습니다.");
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.getWrkComnRegApyInfo(false);
      });
    },
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return this.formData;
    },
    chkValidateData() {
      if(this.mandDataChkYn != 'Y'){
        return true;
      }else{
        if(this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != ''){
          return true;
        }else{
          return false;
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ctrt-header {
    padding: 5px 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $--color-light-gray;
    justify-content: flex-end;
    padding: 20px 0px 5px 0px;
  }
  .ctrt-header-sub{
    padding: 20px 0px 5px 0px;
  }
  .ctrt-upload {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    div {
      width: 100%;
    }
  }
.btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
::v-deep {
  .el-row:nth-child(5) {
    .el-form-item__label {
      height: 180px;
      line-height: 180px;
    }
  }
}
</style>
